<template>
    <div class="table-special">
        <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition">
                    <span class="label">ID</span>
                    <div class="input-condition">
                        <el-input v-model="condition.id" placeholder="请输入id"></el-input>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">标题</span>
                    <div class="input-condition">
                        <el-input v-model="condition.title" placeholder="请输入标题"></el-input>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">发布人</span>
                    <div class="input-condition">
                         <el-input v-model="condition.editor" placeholder="请输入发布人名字"></el-input>
                    </div>
                </div>
                <div class="search-condition search-condition-time" style="min-width: 400px;">
                    <span class="label">发布时间</span>
                    <div class="input-condition">
                        <el-date-picker
                                v-model="condition.time2"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="请选择开始日期"
                                end-placeholder="请选择结束日期"
                                align="right"
                                value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                @change="pickerChangeFn2"
                        >
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="btn-condition">
                <el-button type="primary" @click="handleSearch()">查 询</el-button>
                <el-button  @click="resetSearch()">清空条件</el-button> 
            </div>
        </div>
        <el-table
                :data="list"
                style="width: 100%"
                :highlight-current-row="true"
                stripe
                tooltip-effect="dark"
                ref="multipleTable"
                v-loading="isLoading"
                @selection-change="selectItem"
                header-cell-class-name="table-back"
                class="list-table"
        >
        <template slot="empty">
            <p>{{dataText}}</p>
        </template>
            <el-table-column type="selection" width="50" ></el-table-column>
            <el-table-column  label="ID" prop="id"  width="80" ></el-table-column>
            <el-table-column  label="标题" prop="title" width="400">
                <template scope="scope">
                    <a v-if="scope.row.url" :href="scope.row.url" target="_blank" style="text-decoration:none;">{{scope.row.title}}</a>
                    <span v-else>{{scope.row.title}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="分类" prop="categories_name" width="100"></el-table-column>
            <el-table-column  label="发布人" prop="editor" ></el-table-column>
            <el-table-column  label="发布时间" prop="created_at"  width="180"></el-table-column>
            <el-table-column label="操作" width="220px"  fixed="right">
                <template slot-scope="scope">
                    <Permission allowed="operating.news.drafts-common-list.edit" isRow="1">
                        <a class="edit_a" :href="scope.row.edit_url">编辑</a>
                    </Permission>

                    <Permission allowed="operating.news.drafts-common-list.delete" isRow="1">
                        <el-button size="mini" @click="deleteNews(scope.$index, scope.row)"
                        >删除</el-button>
                    </Permission>
                </template>
            </el-table-column>
        </el-table>
        <template v-if="list.length > 0">
            <el-pagination background layout="total,prev, pager, next" :total="pages.total" :page-size="pages.size" @current-change="currentChange"></el-pagination>
        </template>
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getCommonNews,deleteCommonNews} from '@/service/allNewsList'
    import { parseTime } from '@/utils'
    export default {
        name: "draftsList",
        components: {
        },
        data () {
            return {
                sels: [],
                downloadList: [],
                pages:{
                    total:0,
                    size:1,
                },
                condition: {
                    id: '',
                    title: '',
                    operateID: '',
                    name: '',
                    time:'',
                    time2:'',
                    updatorID:'',
                    editor:''
                },
                categoryList:'',
                isLoading: false,
                dataText: "", //进去页面先让字样为空
                site_name:'',
                list:[]
            }
        },
        computed: {
        },
        mounted () {
            this.initData()
        },
        methods: {
            pickerChangeFn1(val){
                if(val == null){
                    this.condition.time=''
                }
            },
            pickerChangeFn2(val){
                if(val == null){
                    this.condition.time2=''
                }
            },
            selectItem (val) {
                this.sels = val // 返回的是选中的列的数组集合
            },
            handleSearch() {
                this.refreshPage(1);
            },
            resetSearch() {
                this.condition = {
                    id: '',
                    title: '',
                    operateID: '',
                    name: '',
                    time:'',
                    time2:'',
                    updatorID:'',
                    editor:''
                }
                this.refreshPage();
            },
            handleAdd(index, row) {
                this.$router.push({name:'add'});
            },
            currentChange(page) {
                this.page = page;
                this.refreshPage();
            },
            async refreshPage(type) {
                this.dataText = "";
                let query = {}
                let form =  this.condition
                query['id'] = form.id
                query['name'] = form.name
                query['title'] = form.title
                query['editor'] = form.editor
                // query['operator_id'] = form.operateID
                // query['update_id'] = form.updatorID;
                // if(form.time && form.time.length>1) {
                //     query['updated_at_start'] = form.time[0]
                //     query['updated_at_end'] = form.time[1]
                // }
                query['status'] = '1'
                if(form.time2 && form.time2.length>1) {
                    query['created_at_start'] = form.time2[0]
                    query['created_at_end'] = form.time2[1]
                }
                if(!type){
                    query['page'] = this.page
                }
                this.isLoading = true
                await getCommonNews(query).then((data) => {
                    let listData = data
                    this.list = listData.data
                    this.list.forEach((item)=>{
                        item.edit_url = location.origin+'/#/operation/newsManage/draftsList/edit?id='+item.id
                    })
                    this.pages.size = data.pre_page
                    this.pages.total = data.total
                    if (this.list.length === 0) {
                        this.dataText = "暂无数据";
                    }
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            deleteNews(index,row) {
                this.$confirm('删除后，前台将删除该资讯展示，是否确认?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCommonNews(row.id).then(() => {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        this.refreshPage();
                    }).catch(err => {
                        this.$message({
                            type: 'error',
                            message: err.message || '删除失败'
                        })
                    })
                })
            },
            /** 初始化数据请求 */
            async initData () {
                // 初始化之前设置当前页面的loading状态
                // 模拟fetch请求数据....
                this.refreshPage();
            },
            getExtraData (data) {
                if (data.length <= 0) return ''
                for (let i in data) {
                     return data[i].key + ":" + data[i].value + "\n"
                }
            },
        }
    }
</script>

<style scoped>
.edit_a{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    transition: .1s;
    font-weight: 500;
    font-size: 12px;
    border-radius: 3px;
    padding: 7px 15px;
    text-decoration: none;
    margin-right:10px;
}
.edit_a:hover{
    color: #409EFF!important;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
</style>